export default [
  {
    title: '客户机构',
    fixed: 'left',
    dataIndex: 'userRootDeptName',
    key: 'userRootDeptName',
    width: 150
  },
  {
    title: '订单编号',
    fixed: 'left',
    dataIndex: 'orderNumber',
    key: 'orderNumber',
    width: 270
  },
  {
    title: '总金额',
    dataIndex: 'price',
    key: 'price',
    width: 100,
    scopedSlots: { customRender: 'price' }
  },
  {
    title: '商品名称',
    dataIndex: 'goodName',
    key: 'goodName'
  },
  {
    title: '商品购买数量',
    width: 80,
    dataIndex: 'amountPerDevice',
    key: 'amountPerDevice'
  },
  {
    title: '设备数量',
    dataIndex: 'totalAmount',
    width: 70,
    key: 'totalAmount',
    scopedSlots: { customRender: 'totalAmount' }
  },
  // {
  //   title: '设备详情',
  //   dataIndex: 'devices',
  //   width: 70,
  //   key: 'devices',
  //   scopedSlots: { customRender: 'devices' }
  // },
  {
    title: '支付状态',
    width: 100,
    dataIndex: 'payState',
    key: 'payState',
    scopedSlots: { customRender: 'payState' }
  },
  {
    title: '支付类型',
    dataIndex: 'payType',
    key: 'payType',
    scopedSlots: { customRender: 'payType' }
  },
  {
    title: '支付平台单号',
    dataIndex: 'transactionNo',
    key: 'transactionNo'
  },
  {
    title: '更新时间',
    dataIndex: 'updatedAt',
    key: 'updatedAt'
  }
]
